export const ManifestActionTypes = {
    API_RESPONSE_SUCCESS: '@@manifest/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@manifest/API_RESPONSE_ERROR',
    GET_MANIFEST: '@@manifest/GET_MANIFEST',
    RESET_STATE: '@@manifest/RESET_STATE',
    RESET_ALL_ERRORS: '@@manifest/RESET_ALL_ERRORS',
};
